//To prevent collisions with other tools using same key.
const STORAGE_PREFIX = 'natcom_store_';

export const localStorageSet = (key, value) => {
  try {
    if (typeof value === 'object' || typeof value === 'array' || typeof value === 'boolean') {
      value = JSON.stringify(value);
    }

    if (typeof value === 'string') {
      localStorage.setItem(STORAGE_PREFIX + key, value);
    }

    //if e.g. no access to local storage or storage full
  } catch {}
};

export const localStorageGet = (key) => {
  try {
    const item = localStorage.getItem(STORAGE_PREFIX + key);

    if (!item) return;

    if (item[0] === '{' || item[0] === '[' || item === 'false' || item === 'true') return JSON.parse(item);

    return item;
  } catch {}
};

export const localStorageRemove = (key) => {
  try {
    localStorage.removeItem(STORAGE_PREFIX + key);
  } catch {}
};

export const sessionStorageSet = (key, value) => {
  try {
    if (typeof value === 'object' || typeof value === 'array' || typeof value === 'boolean') {
      value = JSON.stringify(value);
    }

    if (typeof value === 'string') {
      sessionStorage.setItem(STORAGE_PREFIX + key, value);
    }

    //if e.g. no access to local storage or storage full
  } catch {}
};

export const sessionStorageGet = (key) => {
  try {
    const item = sessionStorage.getItem(STORAGE_PREFIX + key);

    if (!item) return;

    if (item[0] === '{' || item[0] === '[' || item === 'false' || item === 'true') return JSON.parse(item);

    return item;
  } catch {}
};

export const sessionStorageRemove = (key) => {
  try {
    sessionStorage.removeItem(STORAGE_PREFIX + key);
  } catch {}
};
